<template>
  <json-excel
    class="btn btn-kne-orange pull-right"
    :data="formattedData"
    :fields="searchFields"
    :name="name"
  >
    {{$t('OrderCurrent.modal.billing.generate_excel_sheet')}}
  </json-excel>
</template>

<script>
import JsonExcel from 'vue-json-excel'

export default {
  name: 'CustomExcelSearch',
  components: {
    JsonExcel
  },

  props: {
    name: {
      type: String,
      required: true
    },
    searchData: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      searchFields: {
        'Order Number': 'orderNb',
        'Segment': 'segment',
        'Reference': 'reference',
        'Date': {
          field: 'date',
          callback: (value) => {
            if (!value) return ''
            const date = new Date(value)
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
          }
        },
        'Status': 'status',
        'Driver': 'driver',
        'VIN': 'vin',
        'Pickup': 'pickup',
        'Delivery': 'delivery',

        'Segment Price': {
          field: 'segmentPrice',
          callback: (value) => {
            if (!value) return ''
            return '$' + value.toFixed(2)
          }
        },

        'Total Price': {
          field: 'totalPrice',
          callback: (value) => {
            if (!value) return ''
            return '$' + value.toFixed(2)
          }
        },

        'Billing': 'billing',
        'Message': 'message',
        'Source': 'source'
      }
    }
  },

  computed: {
    formattedData () {
      if (!this.searchData || !this.searchData.deliveries) {
        return []
      }

      const rows = []

      this.searchData.deliveries.forEach((delivery) => {
        const history = delivery.historySync || {}
        const segmentKeys = Object.keys(history)

        if (segmentKeys.length > 0) {
          const totalPrice = segmentKeys.reduce((sum, key) => {
            const seg = history[key] || {}
            return sum + (Number(seg.price) || 0)
          }, 0)

          segmentKeys.forEach((key, index) => {
            const seg = history[key] || {}
            rows.push({
              orderNb: delivery.orderNb || '',
              segment: key || '',
              reference: delivery.reference || '',
              date: seg.pickDate || delivery.date || '',
              status: delivery.status || '',
              driver: seg.chauffeurName || delivery.driver || '',
              vin: delivery.vin || '',
              pickup: seg.transmitter || delivery.pickup || '',
              delivery: seg.receiver || delivery.delivery || '',
              segmentPrice: Number(seg.price) || 0,
              totalPrice: index === 0 ? totalPrice : '',
              billing: delivery.billing || '',
              message: delivery.message || '',
              source: delivery.source || ''
            })
          })
        } else {
          rows.push({
            orderNb: delivery.orderNb || '',
            segment: '',
            reference: delivery.reference || '',
            date: delivery.date || '',
            status: delivery.status || '',
            driver: delivery.driver || '',
            vin: delivery.vin || '',
            pickup: delivery.pickup || '',
            delivery: delivery.delivery || '',
            segmentPrice: Number(delivery.price) || 0,
            totalPrice: Number(delivery.price) || 0,
            billing: delivery.billing || '',
            message: delivery.message || '',
            source: delivery.source || ''
          })
        }
      })

      return rows
    }
  }
}
</script>
